export enum ChartType {
  Pie = 'pie',
  Bar = 'bar',
  Line = 'line',
}
